import {useRef} from "react";
import Textarea from "./Textarea";

function FormContent({note, setNote, valid, setValid}) {
  const ref = useRef(null);

  function onChangeHandler(event) {
    if (event.target.id === "newNote" && ref.current) {
      ref.current.style.height = "auto";
      ref.current.style.height = `${event.target.scrollHeight + 1}px`;
    };

    const {value, name} = event.target;
    setNote({...note, [name]: value});
    setValid(true);
  }

  return (
    <>
      <fieldset className="form-fieldset">
        <label htmlFor="title" className="form-label">Title</label>
        <input 
          className="form-input" 
          id="title" 
          name="title" 
          type="text"
          onChange={onChangeHandler} 
          value={note.title}>
        </input>
      </fieldset>
      <Textarea
        node={ref}
        note={note}
        valid={valid}
        onChangeHandler={onChangeHandler}
      />
    </>
  );
}

export default FormContent;